<template>
<div role="tablist" class="w-100">
  <b-card no-body class="mb-4">
    <b-card-header header-tag="header" class="p-1 px-3" role="tab">
      ユーザー情報
    </b-card-header>
    <b-card-body>
      <b-form-group label="名前">
        <b-form-input type="text" v-model="$store.state.auth.name" disabled></b-form-input>
      </b-form-group>

      <b-form-group label="メールアドレス">
        <b-form-input type="text" v-model="$store.state.auth.email" disabled></b-form-input>
      </b-form-group>

      <b-button class="mt-3 mb-4 w-100" variant="danger" @click="signout">サインアウト</b-button>
    </b-card-body>
  </b-card>

  <b-card no-body class="mb-4">
    <b-card-header header-tag="header" class="p-1 px-3" role="tab">
      申込みプラン
    </b-card-header>
    <b-card-body>
      <p>
        <strong>現在の状況</strong><br>
        <span v-if="$store.state.auth.ticket">
          <span v-if="$store.state.auth.ticket === 'trial'">無料お試し版</span>
          <span v-if="$store.state.auth.ticket === 'basic'">ベーシック版</span>
          <span v-if="$store.state.auth.ticket === 'premium'">プレミアム版</span>
          <template v-if="$store.state.auth.ticket_expires_at < '2090'">
            <br>
            {{ moment($store.state.auth.ticket_expires_at).format("YYYY/MM/DD") }}まで
          </template>
        </span>
        <span v-if="!$store.state.auth.ticket">
          ご利用になるには、いずれかのプランにお申し込みください。
        </span>
      </p>

      <p>
        <b-button class="w-100 mb-1" variant="primary" @click="buyTicket($event, 'basic', 'payjp')" :disabled="$store.state.auth.ticket === 'basic' || $store.state.auth.ticket === 'premium'">
          <strong>ベーシック版</strong><br>
          <span>利用料　年額550円（税込）</span>
          <br>
          <template v-if="$store.state.auth.ticket_expires_at < '2090'">
            クレジットカードで支払う
          </template>
          <br>
          <br>
          <span>『聖書　聖書協会共同訳　旧約聖書続編付き』</span><br>
        </b-button>
      </p>

      <p>
        <b-button class="w-100 mb-1" variant="primary" @click="buyTicket($event, 'premium', 'payjp')" :disabled="$store.state.auth.ticket === 'premium'">
          <strong>プレミアム版</strong><br>
          <span>利用料　年額2,200円（税込）</span>
          <br>
          <template v-if="$store.state.auth.ticket_expires_at < '2090'">
            クレジットカードで支払う
<!--
          <b-button class="w-100" variant="primary" @click="buyTicket($event, 'premium', 'paypal')" :disabled="$store.state.auth.ticket === 'premium'">
            PayPalで支払う
          </b-button>
-->
          </template>
          <br>
          <br>
          <span>『聖書　聖書協会共同訳　旧約聖書続編付き』</span><br>
          <span>『聖書　新共同訳　旧約聖書続編付き』</span><br>
          <span>『聖書　1954年、1955年改訳（口語訳）』</span><br>
          <span>『The Holy Bible, English Standard Version』</span><br>
          <span>『聖書スタディ版』傍注</span>
        </b-button>
      </p>

      <!--
      <p>
        ※お支払いはPayPalを通じてのみ承っています。
      </p>
      -->
    </b-card-body>
  </b-card>

  <b-card no-body class="mb-4">
    <b-card-header header-tag="header" class="p-1 px-3" role="tab">
      パスワード変更
    </b-card-header>
    <b-card-body>
      <b-form @submit="changePassword" class="w-100" ref="form">
        <b-form-group
          label="新しいパスワード">
          <base-togglable-password
            v-model="user.password"
            placeholder="入力してください"
            />
          <base-error-feedback :errors="errors.password"></base-error-feedback>
        </b-form-group>
        <b-form-group
          class="mb-4"
          label="">
          <b-button type="submit" variant="primary" class="w-100">パスワード変更</b-button>
        </b-form-group>
      </b-form>
    </b-card-body>
  </b-card>

  <b-card no-body class="mb-4">
    <b-card-header header-tag="header" class="p-1 px-3" role="tab">
      メールアドレス変更
    </b-card-header>
    <b-card-body>
      <b-form @submit="challengeChangeEmail" class="w-100" ref="form">
        <b-form-group
          label="新しいメールアドレス">
          <input
            class="form-control"
            type="text"
            v-model="user.email"
            placeholder="入力してください">
          <base-error-feedback :errors="errors.email"></base-error-feedback>
        </b-form-group>
        <b-form-group
          class="mb-4"
          label="">
          <b-button type="submit" variant="primary" class="w-100">メールアドレス変更</b-button>
        </b-form-group>
      </b-form>
    </b-card-body>
  </b-card>

  <b-card no-body class="mb-4">
    <b-card-header header-tag="header" class="p-1 px-3" role="tab">
      聖書協会からのお知らせメール
    </b-card-header>
    <b-card-body>
      <p>
        <strong>現在の状況</strong><br>
        <span v-if="$store.state.auth.is_enabled_ad">受信する</span>
        <span v-if="!$store.state.auth.is_enabled_ad">受信しない</span>
      </p>

      <p v-if="!$store.state.auth.is_enabled_ad">
        <b-button class="w-100" variant="primary" @click="toggleIsEnabledAd($event, 1)">
          配信を開始にする
        </b-button>
      </p>

      <p v-else>
        <b-button class="w-100" variant="danger" @click="toggleIsEnabledAd($event, 0)">
          配信を停止する
        </b-button>
      </p>

      ※変更が反映されるまで数日かかる場合がございます。
    </b-card-body>
  </b-card>

  <b-card no-body class="mb-4 text-danger">
    <b-card-header header-tag="header" class="p-1 px-3" role="tab">
      アカウント削除
    </b-card-header>
    <b-card-body>
      アカウントを削除すると、お客様のデータは完全に削除されます。ご利用期間の途中であっても、ご利用いただけなくなります。もう一度、ご利用になる場合は、再度、会員登録をいただくことになります。
      <b-button class="mt-3 mb-4 w-100" variant="danger" @click="resign">アカウントを削除する</b-button>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import jQuery from 'jquery'
import moment from 'moment'

export default {
  data: function () {
    return {
      moment: moment,
      formatter: new Intl.NumberFormat('ja-JP'),
      user: {
        email: '',
        password: '',
      },
      errors: {
      },
    };
  },
  computed: {
    computed: {
      get () {
        return {
          search: {
          },
        }
      },
      set (value) {},
    },
  },
  methods: {
    signout () {
      this.$store.dispatch('authSignout')
    },
    resign () {
      if (confirm('アカウントを削除すると、お客様のデータは完全に削除されます。ご利用期間の途中であっても、ご利用いただけなくなります。もう一度、ご利用になる場合は、再度、会員登録をいただくことになります。')) {
        this.$store.dispatch('authResign')
      }
    },
    changePassword () {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authChangePassword', this.user).then(() => {
        this.user.password = '';
        this.errors = {}
      }).catch((error) => {
        this.errors = error.response.data.errors
      })
    },
    challengeChangeEmail () {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authChangeEmail', this.user).then(() => {
        this.user.email = '';
        this.errors = {}
      }).catch((error) => {
        this.errors = error.response.data.errors
      })
    },
    buyTicket ($event, item, provider) {
      event.preventDefault()

      if (provider === 'payjp') {
        location.href = process.env.VUE_APP_API_BASE_URL + 'payment/payjp/pay/' + item
      }

      this.errors = {}
      this.$store.dispatch('paymentPay', {
          item: item,
          provider: provider,
      }).then((response) => {
        this.errors = {}
        this.$store.dispatch('uiRequest', null)
        location.href = response.data
      }).catch((error) => {
        this.$store.dispatch('authMe')
      })
    },
    toggleIsEnabledAd ($event, value) {
      event.preventDefault()
      this.errors = {}
      this.$store.dispatch('authToggleIsEnabledAd', value).then((response) => {
        this.errors = {}
        this.$store.dispatch('authMe')
      }).catch((error) => {
        this.$store.dispatch('authMe')
      })
    },
  },
  async mounted () {
  },
};
</script>

<style lang="scss">
</style>


